module.exports = __webpack_public_path__ + "img/poster2.d703893a.jpg";